import { useTranslation } from "react-i18next";
import { DateUtils } from "../../../../../utils";
import './RectificationCard.scss';
import { useHistory } from "react-router-dom";

export const RectificationCard = ({
  rectification, petition, hasAction = true
}) => {
  const {t} = useTranslation();
  const history = useHistory();
  const clickable = hasAction && ['PENDING', 'DATA_COMPLETED', 'REGISTERED'].includes(rectification.status);
  return (
    <button
      key={rectification.id}
      className="RectificationCard"
      type="button"
      aria-label={t('Globals.seeRequest')}
      onClick={clickable ? () => {
        if (rectification.status === 'REGISTERED') history.push(`/petitions/${petition.petitionId}/rectifications/${rectification.id}`, {
          petition: petition
        })
        else history.push(`/petitions/${petition.petitionId}/rectifications/new`, {
          rectifications: true, procedureId: rectification.id, petition
        })
      } : null}
    >
      <img 
        className='icon-left'
        src={rectification.status === 'REGISTERED' ? "/misc/icons/step-ok.png" : "/misc/icons/status-pendingDoc.png"}
      />
      <div className="document-data">
        <div className="document-data-row">
          <div className="document-column">
            <p className="document-column-title">{t('Petitions.rectifications.rectificationsList.status')}</p>
            <p className="document-column-value">{rectification.statusTitle}</p>
          </div>
          <div className="document-column">
            <p className="document-column-title">{t('Petitions.rectifications.rectificationsList.creationDate')}</p>
            <p className="document-column-value">{DateUtils.getFormatedDate(rectification.creationTime)}</p>
          </div>
          <div className="document-column">
            <p className="document-column-title">{rectification.status === 'REGISTERED' ? t('Petitions.rectifications.rectificationsList.presentationDate') : t('Petitions.rectifications.rectificationsList.updateTime')}</p>
            <p className="document-column-value">{DateUtils.getFormatedDate(rectification.statusTime)}</p>
          </div>
          {
            rectification.registerNumber && (
              <div className="document-column">
                <p className="document-column-title">{t('Petitions.rectifications.rectificationsList.registerNumber')}</p>
                <p className="document-column-value">{rectification.registerNumber}</p>
              </div>
            )
          }
        </div>
      </div>
    </button>
  );
}